<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_no">TNA Form No.</label>
                                <input type="number"
                                       v-model="search_data.form_no"  v-validate="{ regex: /^[0-9]+$/ }" id="form_no"
                                       name="form_no"
                                       class="form-control form-control-sm"
                                       placeholder="Search by form No"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="name">Household Head Name</label>
                                <input type="text"  v-model="search_data.name" id="name" name="name"
                                        class="form-control form-control-sm"
                                        placeholder="Search by Name"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_training_trade_id">Training Trade</label>
                                <select v-model="search_data.c_training_trade_id"
                                        id="c_training_trade_id" name="c_training_trade_id" class="form-control form-control-sm">
                                    <option :value="''" selected>Select Training Trade</option>
                                    <option v-for="(trade) in trades" :key="trade.id" :value="trade.id">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="batch_no">Batch No</label>
                                <select v-model="search_data.batch_no" id="batch_no" name="batch_no" class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch no.</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                </select>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2"  @click.prevent="search">Search
                        </button>
                    </form>
                </b-card>

                <b-card>
                    <div v-if="traineeFiles.total > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ traineeFiles.total }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Files</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(trainee, index) in traineeFiles.data" :key="index">
                                <td width="20%">
                                    <router-link :to="{
                                    name: 'traineeView',
                                    params: { trainee_id: trainee.id }}" tag="a" target="_blank">{{ trainee.name }}
                                    </router-link>
                                </td>
                                <td>
                                    <table class="table table-centered table-striped">
                                        <thead>
                                        <tr>
                                            <th>Sl</th>
                                            <th>File</th>
                                            <th>Caption</th>
                                            <th>Category</th>
                                            <th>Remark</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(traineeFile) in trainee.files" :key="traineeFile.id" >
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                <a :href="traineeFile.name" target="_blank">
                                                    <img class="rounded-circle" :src="traineeFile.name" alt="" width="30px" height="30px"/>
                                                </a>
                                            </td>
                                            <td>{{ traineeFile.caption }}</td>
                                            <td>{{ traineeFile.category.desc }}</td>
                                            <td>{{ traineeFile.remarks }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <h5 v-if="trainee.files.length === 0" class="text-center text-secondary">
                                        No File Found
                                    </h5>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5  v-if="traineeFiles.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                    <div class="float-right">
                        <pagination :data="traineeFiles" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "List Trainee",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Search Trainee",
                items: [
                    {
                        text: "Trainee",
                        href: "/"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],
                traineeFiles: {},
                search_data: {
                    form_no: '',
                    name: '',
                    c_training_trade_id: '',
                    batch_no: '',
                },
                trades: [],
            };
        },

        mounted() {
            this.getTrainingTrade();
            this.getCodes();
        },
        methods: {
            getSes() {
                http.get("api/trainees").then(response => {
                    if (!response.data.error) {
                        this.traineeFiles = response.data.traineeFiles;
                    }
                });
            },
            getCodes() {
                http.get("api/ses/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.villages = data.villages;
                    }
                });
            },
            search() {
                http.post("api/trainee/files/search", this.search_data).then(response => {
                    if (!response.error) {
                        this.traineeFiles = response.data.traineeFiles;
                    }
                });
            },
            getResults(page = 1) {
                http.post('api/trainee/files/search?page=' + page, this.search_data)
                    .then(response => {
                        this.traineeFiles = response.data.traineeFiles;
                    });
            },
            getTrainingTrade() {
                http.get("api/getTrainingTrade/").then(response => {
                    if (!response.error) {
                        this.trades = response.data.trades;
                    }
                });
            },
        },
    };
</script>
